import { z } from 'zod';

export const SearchSchema = z.object({
  traceableSaasId: z.string().optional(),
});
